export const mainHeader = "Vehicle Detail Lookup";

export const inputPlaceHolders = {
    ID: "CAP ID",
    CODE: "CAP Code"
}

export const formButton = "Submit";
